import { Container } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { LOCATION_GEO_BUTTON_CONFIG } from "../../../other/constants/AddressGeoButtonConfig.jsx";
import { geoLocationButtonUrlHelper } from "../../../other/utils/utils.jsx";

class SwivuAddressContainer extends Container {
  static get $name() {
    return "SwivuAddressContainer";
  }

  static get type() {
    return WIDGET_KEYS.swivuAddressContainer;
  }

  static get configurable() {
    return {
      ...super.configurable,
      layoutStyle: {
        flexWrap: "nowrap"
      },
      items: {
        swivuAddressPicker: {
          type: WIDGET_KEYS.swivuAddressPicker,
          listeners: {
            swivuLocationChange: "up.onLocationChange",
            swivuLocationResolved: "up.onLocationResolved",
            swivuLocationUnresolved: "up.onLocationUnresolved"
          }
        },
        locationButton: {
          type: "button",
          text: "Locate",
          cls: "swivu-disabled-style text-[#048ded]",
          width: "120px",
          menu: {
            listeners: {
              beforeShow: "up.onLocationMenuBeforeShow",
            },
            items: LOCATION_GEO_BUTTON_CONFIG.map(({ title, icon, url }) => {
              return {
                href: url,
                target: "_blank",
                cls: "group no-underline",
                contentElementCls: "!no-underline flex items-center justify-between pr-[1.5em] relative",
                html: `<span class="flex items-center gap-3"><img src='${icon}' class="w-[1.25em] h-[1.25em]" />${title} </span><i style="rotate: -45deg;" class="fa-solid fa-arrow-right-long opacity-0 group-hover:opacity-100 transition-opacity duration-200 absolute right-[.1em]"></i>`
              };
            })
          }
        }
      }
    };
  }

  /* The save button in the editor uses widget.value so this getter will return the value in record  */
  get value() {
    return this.entityRecord?.[this.swivuRecordField];
  }

  /* As we implemented a value getter so we are also implmenting the setter, We are also using this setter to update record */
  set value(value) {
    this.entityRecord[this.swivuRecordField] = value;
  }

  /* We had to disable both the picker field & location button, so creating a setter for disabled property */
  set disabled(isDisabled) {
    const { swivuAddressPicker, locationButton } = this.widgetMap;
    swivuAddressPicker.disabled = isDisabled;

    // Only disable buttons if the location is unresolved
    const { lat, lon } = this.value ?? {};
    if(lat && lon) locationButton.disabled = isDisabled;
  }


  /* This listener is triggered by SwivuAddressPicker field, when the user selects a location is wanting a change in the address */
  onLocationChange({ record, value }) {
    if (record) {
      const { formattedAddress, lat, lon } = record;
      this.value = {
        formatted_address: formattedAddress,
        lat,
        lon
      };
    } else {
      this.value = {
        formatted_address: value,
        lat: null,
        lon: null
      };
    }
  }

  /* This listener will be triggered by SwivuAddressPicker field when the location is resolved */
  onLocationResolved() {
    this.toggleLocateButton(true);
  }

  /* This listener will be triggered by SwivuAddressPicker field when the location becomes unresolved */
  onLocationUnresolved() {
    this.toggleLocateButton(false);
  }

  loadRecord(record) {
    // Initialize container with record
    if (window.googleMapsLoaded) {
      this.init(record);
    } else {
      window.addEventListener("googleMapsLoaded", () => {
        this.init(record);
      });
    }
  }

  init(record) {
    const { swivuAddressPicker } = this.widgetMap;
    this.entityRecord = record;
    swivuAddressPicker.init(record); // initialize SwivuAddressPicker field
  }

  /* This listener will update the menu buttons href's with updated lat & lon value */
  onLocationMenuBeforeShow({ source }) {
    const { lat, lon } = this.value;
    source.items.forEach((item, index) => {
      item.href = geoLocationButtonUrlHelper(LOCATION_GEO_BUTTON_CONFIG[index].url, { lat, lon });
    })
  }

  toggleLocateButton(isEnabled) {
    this.widgetMap.locationButton.disabled = !isEnabled;
  }
}

SwivuAddressContainer.initClass();
